import { useRef, useEffect } from 'react';
import { getUrl, getParents } from '../../utils';
import constantes from '../../resources/constantes.json';

export const esPagina = id => id != null && Number.isInteger(id) && id >= 0;
export const existePagina = (id, eleccion, nomenclator) =>
  nomenclator.ambitos[eleccion][id] != null;

export const useNameUrl = ({
  id,
  eleccion,
  nomenclator,
  isValid,
  pathname,
  history,
  page,
  idHistorico,
  parentLevel,
  mesa,
}) => {
  const lastPathnameRef = useRef();
  useEffect(() => {
    if (lastPathnameRef.current !== pathname && isValid) {
      lastPathnameRef.current = pathname;
      history.replace(
        getUrl({
          id,
          eleccion,
          nomenclator,
          page,
          idHistorico,
          parentLevel,
          mesa,
        })
      );
    }
  });
};

export const getTitle = (id, eleccion, nomenclator, page, t, parentLevel) => {
  let texto = '';
  const genealogy = [
    ...getParents(id, eleccion, nomenclator, parentLevel).reverse(),
    id,
  ];
  for (const x of genealogy) {
    const ambito = nomenclator.ambitos[eleccion][x];
    texto = ambito.n + ' - ' + texto;
  }
  texto = texto.slice(0, -3);
  if (id === 0) {
    texto = nomenclator.ambitos[eleccion][id].n;
  }
  switch (page) {
    case 'inicio':
      return `${texto}`;
    default:
      return `Resultados de las elecciones a ${t(page)} en ${texto}`;
  }
};

export const getDataUrl = ({
  id,
  eleccion,
  page,
  nomenclator,
  idHistorico,
  extension = 'json',
  parentLevel,
  mesa = '',
}) => {
  const ambito =
    page === 'inicio'
      ? nomenclator.ambitos[constantes.eleccion['inicio']][id]
      : nomenclator.ambitos[eleccion][id];
  if (ambito == null) return undefined;
  const codigoAmbito = mesa ? mesa : ambito.c;
  const carpetaEleccion =
    constantes.nomAmbitos[constantes.nombreEleccion[eleccion]];
  const mesaId = mesa ? mesa.slice(1, 7) : '';
  if (idHistorico == null) {
    if (page === 'inicio') {
      return `/json/INI/${carpetaEleccion}/IN_${codigoAmbito}.${extension}`;
    }
    return `/json/ACT/${carpetaEleccion}/${codigoAmbito}.${extension}`;
  }

  const parents = getParents(id, eleccion, nomenclator, parentLevel);
  let codigoDepartamento;
  for (const parent of parents) {
    const ambitoParent = nomenclator.ambitos[eleccion][parent];
    if (ambitoParent.l === constantes.level.departamento) {
      codigoDepartamento = ambitoParent.c;
      break;
    }
  }

  if (ambito.l <= constantes.level.departamento) {
    codigoDepartamento = nomenclator.ambitos[eleccion][id].c;
  }

  //ejemplo de url y ruta
  //ruta: /json/HIS/00/ASA/AV_0002/00.json
  //url: historico/AV_0002/asamblea/0/colombia
  return `/json/HIS/${codigoDepartamento}/${carpetaEleccion}/${idHistorico}/${codigoAmbito}${mesaId}.${extension}`;
};
